"use strict";
/**
 * This is a mock implementation of the worker thread functions for the browser.
 * This is here so Webpack won't fail when bundling the browser code.
 *
 * This is in addition to the browser configuration in package.json:
 *   "browser": {
 *     "./dist/runWithWorkerThread": "./dist/runWithWorkerThreadBrowser"
 *   }
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runWithMultipleWorkerThread = exports.runWithWorkerThread = void 0;
const runWithWorkerThread = () => {
    throw new Error("Not implemented for browser");
};
exports.runWithWorkerThread = runWithWorkerThread;
const runWithMultipleWorkerThread = () => __awaiter(void 0, void 0, void 0, function* () {
    throw new Error("Not implemented for browser");
});
exports.runWithMultipleWorkerThread = runWithMultipleWorkerThread;
//# sourceMappingURL=runWithWorkerThreadBrowser.js.map